import { RocCalculator, RocCalculatorOutput } from '@lib/utils';

export function getCurrentCalculatorOutput(rocCalculator: RocCalculator): RocCalculatorOutput {
  return {
    earningCumulativeProb25: rocCalculator.earningCumulativeProb25,
    earningCumulativeProb50: rocCalculator.earningCumulativeProb50,
    earningCumulativeProb75: rocCalculator.earningCumulativeProb75,
    monthlySalary25: rocCalculator.monthlySalary25,
    monthlySalary50: rocCalculator.monthlySalary50,
    monthlySalary75: rocCalculator.monthlySalary75,
    time: rocCalculator.time
  };
}
